import { Navigate, useLocation } from "react-router";

/** Permanent move of a path prefix (`/account/devices/…` → `/account/assets/…`), keeping the rest of the URL. */
export function RedirectPrefix({ from, to }: { from: string; to: string }) {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={`${pathname.replace(from, to)}${search}${hash}`} replace />;
}
